import { Navigate, useLocation, useSearchParams } from 'react-router-dom'
import { useAuth } from '../auth/useAuth'
import { PageMessage } from '../components/PageMessage'

const FAILURE_MESSAGES: Record<string, string> = {
  cancelled: 'Sign in was not completed.',
  provider_error: 'Sign in could not be completed. Please try again.',
  configuration: 'Sign in is not configured correctly. Please contact an administrator.',
}

export function SignInPage() {
  const { status, signIn } = useAuth()
  const location = useLocation()
  const [params] = useSearchParams()
  const error = params.get('error')

  if (status === 'authenticated') {
    const from = (location.state as { from?: string } | null)?.from
    return <Navigate to={from ?? '/events'} replace />
  }

  return (
    <PageMessage title="CustomReg Event Prep" body="Sign in with your work account to continue.">
      {error ? (
        <p role="alert" className="error">
          {FAILURE_MESSAGES[error] ?? FAILURE_MESSAGES.provider_error}
        </p>
      ) : null}
      <button type="button" className="primary" onClick={signIn}>
        Sign in
      </button>
    </PageMessage>
  )
}
